const kuBDLayer3 = [
  [
    [
      94.8078917,
      27.591732
    ],
    [
      95.9507614,
      26.2993576
    ],
    [
      96.7419788,
      24.7532637
    ],
    [
      97.021504,
      23.8099265
    ],
    [
      97.1815441,
      22.9047016
    ],
    [
      97.0654493,
      21.7164507
    ],
    [
      96.7859353,
      20.8254178
    ],
    [
      96.3086303,
      19.7805179
    ],
    [
      95.5111961,
      18.9249561
    ],
    [
      94.5263672,
      18.2803791
    ],
    [
      93.5771091,
      17.7991654
    ],
    [
      92.192394,
      17.4531837
    ],
    [
      90.7638915,
      17.4222942
    ],
    [
      89.0771484,
      17.6207937
    ],
    [
      87.4231956,
      18.0917391
    ],
    [
      86.2255761,
      18.6185124
    ],
    [
      85.1374591,
      19.3906818
    ],
    [
      84.1992188,
      20.2667876
    ],
    [
      83.2275502,
      21.4121622
    ],
    [
      82.7196971,
      22.332058
    ],
    [
      82.4121545,
      23.6401257
    ],
    [
      82.280285,
      25.9531199
    ],
    [
      82.6758937,
      27.7171232
    ],
    [
      83.2372949,
      28.5362745
    ],
    [
      83.9066764,
      29.3382172
    ],
    [
      84.8290721,
      29.9422148
    ],
    [
      85.972633,
      30.3290901
    ],
    [
      87.818807,
      30.480656
    ],
    [
      89.577068,
      30.2152615
    ],
    [
      91.1155464,
      29.7204843
    ],
    [
      92.5221552,
      29.031367
    ],
    [
      93.8408509,
      28.3376187
    ],
    [
      94.8078917,
      27.591732
    ]
  ]
]
const kuBDLayer2 = [
  [
    [
      91.7748916,
      27.9804094
    ],
    [
      90.6320219,
      28.4449789
    ],
    [
      89.3572827,
      28.7535645
    ],
    [
      88.4325877,
      28.8361015
    ],
    [
      87.7308913,
      28.7535645
    ],
    [
      86.9629004,
      28.7419203
    ],
    [
      86.1484564,
      28.2903471
    ],
    [
      84.9616303,
      27.3578609
    ],
    [
      84.5605272,
      26.3524979
    ],
    [
      84.365254,
      25.2579732
    ],
    [
      84.4726353,
      23.9082069
    ],
    [
      84.7858042,
      22.8237382
    ],
    [
      85.4345605,
      21.8252505
    ],
    [
      86.192413,
      20.8664755
    ],
    [
      87.1484277,
      20.2209658
    ],
    [
      88.1704566,
      19.5885608
    ],
    [
      89.2529297,
      19.1636578
    ],
    [
      90.3243263,
      19.008053
    ],
    [
      91.8213395,
      18.9652316
    ],
    [
      92.9617177,
      19.340024
    ],
    [
      93.7304799,
      19.7299484
    ],
    [
      94.412283,
      20.166983
    ],
    [
      95.33537,
      21.5627279
    ],
    [
      95.5566911,
      22.5621841
    ],
    [
      95.4232831,
      23.7116571
    ],
    [
      95.0147297,
      25.0059727
    ],
    [
      93.9727178,
      26.3387371
    ],
    [
      92.9736663,
      27.2112057
    ],
    [
      91.7748916,
      27.9804094
    ]
  ]
]
const kuBDLayer1 = [
  [
    [
      90.0605871,
      25.9443421
    ],
    [
      89.4287109,
      26.0194526
    ],
    [
      88.8298044,
      25.8257645
    ],
    [
      88.3349511,
      25.5886641
    ],
    [
      87.9506739,
      25.1118161
    ],
    [
      87.7539161,
      24.0330598
    ],
    [
      88.2583696,
      22.8642259
    ],
    [
      89.1259654,
      22.0924849
    ],
    [
      90.0605871,
      21.7260716
    ],
    [
      90.703125,
      21.7390912
    ],
    [
      91.3792828,
      21.7668786
    ],
    [
      92.0459377,
      22.115067
    ],
    [
      92.3902829,
      22.5805594
    ],
    [
      92.6416828,
      23.2952043
    ],
    [
      92.2584133,
      24.2335258
    ],
    [
      91.9483038,
      24.8066814
    ],
    [
      91.2034567,
      25.3502692
    ],
    [
      90.0605871,
      25.9443421
    ]
  ]
]

const KuBD = {
  sourceLayer3: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuBDLayer3
      }
    }
  },
  sourceLayer2: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuBDLayer2
      }
    }
  },
  sourceLayer1: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuBDLayer1
      }
    }
  },
  fillLayer3: {
    'id': 'ku-bd-fill3',
    'type': 'fill',
    'source': 'ku-bd-source3',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.45)'

    }
  },
  lineLayer3: {
    'id': 'ku-bd-line3',
    'type': 'line',
    'source': 'ku-bd-source3',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer2: {
    'id': 'ku-bd-fill2',
    'type': 'fill',
    'source': 'ku-bd-source2',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.5)'
    }
  },
  lineLayer2: {
    'id': 'ku-bd-line2',
    'type': 'line',
    'source': 'ku-bd-source2',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer1: {
    'id': 'ku-bd-fill1',
    'type': 'fill',
    'source': 'ku-bd-source1',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.55)'
    }
  },
  lineLayer1: {
    'id': 'ku-bd-line1',
    'type': 'line',
    'source': 'ku-bd-source1',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  }
}

export function KuBDMap(map) {
  map.addSource('ku-bd-source3', KuBD.sourceLayer3);
  map.addSource('ku-bd-source2', KuBD.sourceLayer2);
  map.addSource('ku-bd-source1', KuBD.sourceLayer1);

  map.addLayer(KuBD.fillLayer3);
  map.addLayer(KuBD.fillLayer2);
  map.addLayer(KuBD.fillLayer1);

  map.addLayer(KuBD.lineLayer3);
  map.addLayer(KuBD.lineLayer2);
  map.addLayer(KuBD.lineLayer1);

  return map;
}